
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-analytics",
      function () {
        return require("private-next-pages/product-analytics.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-analytics"])
      });
    }
  